import { render, staticRenderFns } from "./Feedback.component.vue?vue&type=template&id=e95357e8&"
import script from "./Feedback.component.vue?vue&type=script&lang=ts&"
export * from "./Feedback.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports